<template>
  <div class="section" v-if="range">
    <div class="container">
      <div class="container__inner px-1.5">
        <div
          class="relative flex flex-col flex-wrap justify-between w-full lg:flex-row"
        >
          <div class="pt-2 lg:w-6/12 lg:pt-4">
            <div class="flex items-center section-title">
              <CircleIcon
                class="text-black fill-current mr-0.5 h-0.625 w-0.625 lg:h-1 lg:w-1"
              />
              <span class="text-sm uppercase lg:text-base">Mon Ludic</span>
            </div>
            <h1
              class="block m-0 leading-none text-4xl lg:text-6xl font-normal py-1 lg:py-2.5"
              id="quiz_block"
            >
              {{ range.title }}
            </h1>
            <div class="pb-2 entry-content" v-html="range.description"></div>
            <!-- .entry-content -->

            <div v-if="showResultsPdf" class="text-lg">
              <p class="py-1">Votre score : {{ quizStore.getScore() }} %</p>
              <p class="py-1">
                <button @click="downloadPdf" class="bt">
                  <span>Téléchargez vos résultats</span>
                </button>
              </p>
            </div>

            <div v-if="isDev" class="text-lg">
              Score : {{ quizStore.getScore() }} %
            </div>

            <div>
              <ul class="flex flex-wrap items-center p-0 py-2 m-0 list-none">
                <li
                  class="pb-1 pr-1.5"
                  v-if="
                    ['ok', 'other'].includes(range.media) &&
                    quizStore.nextQuestion().segmentId
                  "
                >
                  <RouterLink
                    type="button"
                    class="bt"
                    :to="quizStore.getRoute(quizStore.nextQuestion())"
                  >
                    &Eacute;tape suivante
                  </RouterLink>
                </li>
                <li class="pb-1 pr-1.5" v-if="['ok'].includes(range.media)">
                  <a class="bt" target="_blank" :href="''">
                    <span>La formation en détail</span>
                  </a>

                  <!-- <button type="button" class="bt" @click="showTraining()">
                    La formation en détail
                  </button> -->
                </li>

                <li
                  class="pb-1 pr-1.5"
                  v-if="
                    quizStore.quiz.private == 0 && ['ok'].includes(range.media)
                  "
                >
                  <a
                    :href="
                      'mailto:?subject=' +
                      encodeURIComponent(emailSubject) +
                      '&body=' +
                      encodeURIComponent(emailBody)
                    "
                    class="bt bt--focus"
                  >
                    <span>Partager</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="flex items-end lg:w-5/12">
            <img
              :src="segmentImgs[range.media]"
              class="block img-responsive"
              alt=""
            />
          </div>
        </div>
        <!-- .flex -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->

  <QuizLinks :content_ids="range.links" v-if="range && range.links" />

  <QuizResults />

  <TrainingSuggestions
    :trainings_ids="range.trainings"
    :userId="quizStore.userId"
    v-if="range && range.trainings"
  />

  <div id="pdf_results_container" class="hidden" v-if="showResultsPdf">
    <QuizResultsPdf id="pdf_results" />
  </div>

  <pre v-if="isDev">{{
    {
      startedAt: quizStore.startedAt,
      range,
      next: quizStore.nextQuestion(),
      scores: quizStore.getScores(),
      answers: quizStore.answers,
    }
  }}</pre>
</template>
<script setup>
import { onMounted } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";
import { useQuizStore } from "@/stores/quiz";
import QuizResults from "@/components/QuizResults.vue";
import QuizResultsPdf from "@/components/QuizResultsPdf.vue";
import CircleIcon from "@/components/icons/CircleIcon.vue";
import segmentImgOk from "../assets/img/range/range-ok.png";
import segmentImgKo from "../assets/img/range/range-ko.png";
import segmentImgOther from "../assets/img/range/range-other.png";
import TrainingSuggestions from "@/components/TrainingSuggestions.vue";
import QuizLinks from "@/components/QuizLinks.vue";

import { jsPDF } from "jspdf";
import html2pdf from "html2pdf.js";

const quizStore = useQuizStore();
const route = useRoute();
const router = useRouter();

const props = defineProps({
  segmentId: {
    type: Number,
    required: true,
  },
});

const segmentImgs = {
  ok: segmentImgOk,
  ko: segmentImgKo,
  other: segmentImgOther,
};

quizStore.setStatus(props.segmentId, 0);
quizStore.setCurrentRoute(route.name, route.params);

const segment = quizStore.currentSegment();
const score = quizStore.getScore();
const range = segment.ranges.filter((range) => range.max >= score)[0];

// if no range defined, go to next segment
if (!range) {
  console.log(
    "no range defined, for segment",
    segment.id,
    "go to next segment"
  );
  console.log(
    quizStore.nextQuestion(),
    quizStore.getRoute(quizStore.nextQuestion())
  );
  router.push(quizStore.getRoute(quizStore.nextQuestion()));
}

const showTraining = () => {
  document.getElementById("quiz-container").innerHTML = "";
  document.querySelector("body").style.overflow = "auto";
  // document.getElementById("quiz").remove();
};

const isDev = document.location.hostname === "localhost";

const showResultsPdf =
  range &&
  (!quizStore.nextQuestion().segmentId || ["ok", "ko"].includes(range.media)) &&
  quizStore.quiz.private;

if (
  range &&
  (!quizStore.nextQuestion().segmentId || ["ok", "ko"].includes(range.media))
) {
  fetch(`${import.meta.env.VITE_QUIZ_API_ENDPOINT}/save_score/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      user_id: quizStore.userId,
      quiz_id: quizStore.quiz.id,
      answers: quizStore.answers,
      score: quizStore.getScore(),
      duration: (Date.now() - quizStore.startedAt) / 1000,
    }),
  })
    // .then((r) => r.json())
    .then((r) => {
      // console.log(r);
    })
    .catch((error) => {
      console.log(error);
    });
}

const emailSubject = "Test d’auto-positionnement UdI " + quizStore.quiz.title;
const emailBody =
  "Bonjour,\r\n\r\n" +
  "J’ai réalisé mon test d’auto-positionnement LUDIC sur le site de l’Université de l’Ingénierie et mon niveau correspond à cette formation : " +
  quizStore.quiz.permalink.replace(/#quiz/, "") +
  " .\r\n\r\n" +
  "Je souhaite maintenant échanger avec toi pour valider l’intérêt que je participe à cette formation et finaliser mon inscription.\r\n\r\n";

onMounted(() => {
  setTimeout(function () {
    // console.log("scroll");
    if (document.getElementById("quiz_block"))
      document
        .getElementById("quiz_block")
        .scrollIntoView({ behavior: "smooth" });
  }, 50);
});

const downloadPdf = async () => {
  document.getElementById("pdf_results_container").classList.remove("hidden");
  setTimeout(() => {
    html2pdf()
      .set({
        margin: 0.5,
        filename: "results.pdf",
        pagebreak: { mode: ["css", "avoid-all"], avoid: ".quiz-result-item" },
        // image: { type: "jpeg", quality: 0.98 },
        // html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      })
      .from(document.getElementById("pdf_results_container"))
      .toPdf()
      .save()
      .then(function (pdfObject) {
        document
          .getElementById("pdf_results_container")
          .classList.add("hidden");
      });

    /*
    html2pdf(document.getElementById("pdf_results_container"), {
      margin: 0.5,
      filename: "results.pdf",
      pagebreak: { mode: ["css", "avoid-all"], avoid: ".quiz-result-item" },
      // image: { type: "jpeg", quality: 0.98 },
      // html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    });
    */
  }, 250);
  // let pdf = new jsPDF({
  //   orientation: "p",
  //   unit: "pt",
  //   format: "letter",
  //   putOnlyUsedFonts: true,
  //   compress: true,
  // });
  // const source = document.getElementById("pdf_results_container");

  // await pdf.html(source, {
  //   width: 580,
  //   windowWidth: 580,
  //   margin: 15,
  //   x: 0,
  //   y: 0,
  //   autoPaging: "text",
  // });
  // await pdf.save("resultats.pdf");
};
</script>
